<template>
<div>
    <div class="chartFilter">
        <select class="country_select toUpper" v-if="countryFlag" name="country">
            <option v-for="(items,idx) in countryList" :value="items.id" :key=idx>{{items.name}}</option>
        </select>
        <select class="province_select toUpper" v-if="stateFlag" name="state" v-model="stateId" @change="provinceSelect($event)">
            <option value="" >{{ $t("Filter.selectstate") }}</option>
            <option v-for="(items,idx) in stateList" :key="idx" :value="items.id">{{items.name}}</option>
        </select>
        <select class="region_select toUpper" v-if="distFlag" name="district" v-model="distId" @change="districtChange($event)">
            <option  value="">{{ $t("Filter.selectdistrict") }}</option>
            <option v-for="(items,idx) in districtList" :key="idx" :value="items.id">{{items.name}}</option>
        </select>
        <date-picker class="pl-2" @change=getDate value-type='YYYY-MM-DD' v-model="value1" type="date" range placeholder="Select date range"></date-picker>
        <select class="toUper" v-model="ageGroup" v-show="this.userData.programid == '1262097'">
            <option selected="selected" value="">Select Age Group</option>
                <option value="<"><= 5 Year</option> 
                <option value=">">> 5 Year</option>
        </select>
        <!-- <select class="region_select toUpper" name="city" @change="cityChange($event)">
            <option selected="selected" value="">Select Facility</option>
            <option v-for="(items,idx) in facilityList" :key="idx" :value="items.id">{{items.name}}</option>
        </select> -->
        <!-- <select class="year_select">
        <option selected="selected">Start Year</option>
      </select>
      <select class="month_select">
        <option selected="selected">Select Month</option>
      </select>
      <select class="week_select">
        <option selected="selected">Select Week</option>
      </select> -->
        <button class="btn btn_apply" @click="triggerFilter()">{{ $t("Filter.apply") }}</button>
    </div>
    <div class="stat_counter" style="z-index: 0;">
        <div class="row bottomBorder no-gutters">
            <div class="col-md-1">
                <div class="stat_single_icon">
                    <!-- <img src="../assets/img/LTBI.png"> -->
                    <h6 class="mt-2 text-center">TBI PATHWAY</h6>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        {{ $t("Overview.registration") }}
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('Registration',indexCaseReg,contactCaseScrened)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat stat_left">
                            <div class="num indexCaseReg">{{indexCaseReg}}
                            </div>
                            <div class="title">{{ $t("Overview.index") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num contactCaseScrened">{{contactCaseScrened}}</div>
                            <div class="title">{{ $t("Overview.contacts") }}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="stat_single">
                <div class="icon_title">
                    <span>Index Cases</span>
                </div>
                <div class="stat_text" id="indexCase" >
                    <div class="stat stat_left">
                        <div class="num indexCaseTarget">500</div>
                        <div class="title">Target</div>
                    </div>
                    <div class="stat stat_right">
                        <div class="num indexCaseReg">0</div>
                        <div class="title">Registered</div>
                    </div>
                </div>
            </div> -->
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        <!-- <img src="img/Contact_case.svg"> -->
                        <!-- <span>Contact cases</span> -->
                        {{ $t("Overview.screened") }} / {{ $t("Overview.referred") }} 
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('Screened/Referred',contactCaseScrened,contactCaseTestedLtbi)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="contactCase">
                        <div class="stat stat_left">
                            <div class="num contactCaseScrened">{{contactCaseScrened}}</div>
                            <div class="title">{{ $t("Overview.screened") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num contactCaseTestedLtbi">{{contactCaseTestedLtbi}}</div>
                            <div class="title">{{ $t("Overview.referred") }} </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        <!-- <img src="img/LTBI_test.svg"> -->
                        <!-- {{ $t("Overview.ltbitesting") }} -->
                        TBI TESTING
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('LTBI testing',ltbiTested,ltbiPositive)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="ltbiTesting">
                        <div class="stat stat_left">
                            <div class="num ltbiTested">{{ltbiTested}}</div>
                            <div class="title">{{ $t("Overview.tested") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num ltbiPositive">{{ltbiPositive}}</div>
                            <div class="title">{{ $t("Overview.positive") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        <!-- <img src="img/treatment.svg"> -->
                        TB Preventive Treatment
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('LTBI treatment initiation',ltbiInit,ltbiNonInt)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="ltbiInit">
                        <div class="stat stat_left">
                            <div class="num ltbiInit">{{ltbiInit}}</div>
                            <div class="title">{{ $t("Overview.initiated") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num ltbiNonInt">{{ltbiNonInt}}</div>
                            <div class="title">{{ $t("Overview.notinitiated") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row bottomBorder no-gutters" style="border-bottom:none">
            <div class="col-md-1">
                <div class="stat_single_icon">
                    <!-- <img src="../assets/img/TB.png"> -->
                    <h6 class="mt-2 text-center">{{ $t("Overview.tbpathway") }}</h6>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                         {{ $t("Overview.registration") }}
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('Registration',indexCaseReg,contactCaseScrened)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat stat_left">
                            <div class="num indexCaseReg">{{indexCaseReg}}</div>
                            <div class="title">{{ $t("Overview.index") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num contactCaseScrened">{{contactCaseScrened}}</div>
                            <div class="title">{{ $t("Overview.contacts") }}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="stat_single">
                <div class="icon_title">
                    <span>Index Cases</span>
                </div>
                <div class="stat_text" id="indexCase" >
                    <div class="stat stat_left">
                        <div class="num indexCaseTarget">500</div>
                        <div class="title">Target</div>
                    </div>
                    <div class="stat stat_right">
                        <div class="num indexCaseReg">0</div>
                        <div class="title">Registered</div>
                    </div>
                </div>
            </div> -->
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        <!-- <img src="img/Contact_case.svg"> -->
                        <!-- <span>Contact cases</span> -->
                        {{ $t("Overview.screened") }} / {{ $t("Overview.referred") }} 
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('Screened/Referred',contactCaseScrened,ltbirefered)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="contactCase">
                        <div class="stat stat_left">
                            <div class="num contactCaseScrened">{{contactCaseScrened}}</div>
                            <div class="title">{{ $t("Overview.screened") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num ltbirefered">{{ltbirefered}}</div>
                            <div class="title">{{ $t("Overview.referred") }} </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        <!-- <img src="img/TB_test.svg"> -->
                        {{ $t("Overview.tbtesting") }}
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('TB testing',tb_Tested,tbPositive)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="tbTesting">
                        <div class="stat stat_left">
                            <div class="num tb_Tested">{{tb_Tested}}</div>
                            <div class="title">{{ $t("Overview.tested") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num tbPositive">{{tbPositive}}</div>
                            <div class="title">{{ $t("Overview.positive") }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        <!-- <img src="img/treatment.svg"> -->
                        {{ $t("Overview.tbtreatmentinitiation") }}
                        <!-- <i class="fa fa-info-circle"  @click="getSubIndicator('TB treatment initiation',tbTretInit,tbTretNonInt)" v-b-modal.modal-subindi style="font-size: 15px;vertical-align: top;" aria-hidden="true"></i> -->
                    </div>
                    <div class="stat_text" id="tbInit">
                        <div class="stat stat_left">
                            <div class="num tbTretInit">{{tbTretInit}}</div>
                            <div class="title">{{ $t("Overview.initiated") }}</div>
                        </div>
                        <div class="stat stat_right">
                            <div class="num tbTretNonInt">{{tbTretNonInt}}</div>
                            <div class="title">{{ $t("Overview.notinitiated") }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="content-grid">
        <div class="row align-items-stretch no-gutters">
            <div class="col-lg-6">
                <div class="card map_card">
                    <div class="card-header">
                        <img src="../assets/img/hotspot_map.png">
                        <span>{{ $t("Overview.hotspotdetails") }}</span>
                    </div>
                    <div class="card-body" id="myMap" style="z-index: 0;"></div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row no-gutters">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header">TBI Cascade</div>
                            <div class="card-body" id="ltbiCascade">
                                <highcharts :options="chartOptions" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header">{{ $t("Overview.tbcascade") }}</div>
                            <div class="card-body" id="tbCascade">
                                <highcharts :options="chartOptions2" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-6">
                        <div class="card">
                            <div class="card-header">Testing/Evaluation Overview</div>
                            <div class="card-body" id="testingOverview"></div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-header">Treatment Overview</div>
                            <div class="card-body" id="testingOverview2"></div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <b-modal size="md" id="modal-subindi" hide-footer>
        <template v-slot:modal-title> {{subIndicatorName}} </template>
        <template v-slot:default>
            <div class="stat_single">
                <div class="icon_title">
                    {{subIndicatorName}}
                </div>
                <div class="stat_text" id="indexCase">
                    <div class="stat stat_left">
                        <div class="num indexCaseReg">{{subIndicator1}}</div>
                        <div class="title">
                            <5 years </div> </div> <div class="stat stat_right">
                                <div class="num contactCaseScrened">{{subIndicator2}}</div>
                                <div class="title"> ≥5 years </div>
                        </div>
                    </div>
                </div>
        </template>
    </b-modal>
</div>
</template>

<script>
import ApiServices from '../service/ApiServices'
import INDData from '../assets/IND.json'
import JQuery from 'jquery'
let $ = JQuery

export default {
    name: "home",
    components: {},
    data() {
        return {
            inddata: INDData,
            ageGroup:'',
            subIndicatorName: '',
            subIndicator1: '',
            subIndicator2: '',
            // Variable  for map 
            map: null,
            tileLayer: null,
            alllocations: [],
            //
            indexCaseTarget: '500',
            indexCaseReg: '0',
            contactCaseScrened: '0',
            contactCaseTested: '0',
            tb_Tested: '0',
            tbPositive: '0',
            ltbiTested: '0',
            ltbiPositive: '0',
            tbTretInit: '0',
            tbTretNonInt: '0',
            ltbiInit: '0',
            ltbiNonInt: '0',
            ltbiComplete: '0',
            ltbiDiscon: '0',
            contactCaseTestedLtbi: '0',
            ltbirefered: '0',
            userData: JSON.parse(sessionStorage.getItem('userData')),
            chartOptions: {
                chart: {
                    height: 200,
                    type: "column",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    showInLegend: false,
                    data: []
                }]
            },
            chartOptions2: {
                chart: {
                    height: 200,
                    type: "column",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    showInLegend: false,
                    data: []
                }]
            },
            // Variable for filters
            countryList: [],
            countryFlag: true,
            stateList: [],
            stateId :'',
            stateFlag: true,
            districtList: [],
            distId :'',
            distFlag: true,
            facilityList: [],
            filterOrgid: '',
            value1: '',
            fromDate: '',
            toDate: '',
            tiles: ''
        }
    },
    methods: {
        getDate() {
            console.log(this.value1)
            this.fromDate = this.value1[0]
            this.toDate = this.value1[1]
        },
        // Functions for filter
        getHierarchy(param) {
            this.$root.isLoading = true
            let instance = {
                'orgid': param
            }
            ApiServices.RestPostCall('rtmpro/component/org/hierarchydata', instance).then(res => {
                // console.log(res)
                if (res.data.level == '3') {
                    this.countryList.push(res.data)
                    // console.log(this.countryList, "country")
                    this.stateList = res.data.nodes
                    this.$root.isLoading = false
                }
                if(res.data.level == '4'){
                    this.countryFlag = false
                    // this.distId = JSON.stringify(res.id)
                    this.stateList.push(res.data)
                    this.districtList  = res.data.nodes
                }
                if(res.data.level == '5'){
                    this.countryFlag = false
                    this.stateFlag = false
                    // this.distId = JSON.stringify(res.id)
                    this.districtList.push(res.data)
                }
                // if(res.data.level == '6'){
                //     this.countryFlag = false
                //     this.stateFlag = false
                //     this.distFlag = false
                // }
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });
        },
        provinceSelect(event) {
            let stateId = event.target.value;
            this.filterOrgid = stateId
             let instance = {
                'orgid': stateId
            }
            ApiServices.RestPostCall('rtmpro/component/org/hierarchydata', instance).then(res => {
                this.distId = ''
                this.districtList = res.data.nodes
            })
            // Object.keys(this.stateList).forEach(key => {
            //     if (this.stateList[key].id == stateId) {
            //         this.districtList = this.stateList[key].nodes
            //     }
            // })
        },
        districtChange(event) {
            let distID = event.target.value;
            this.filterOrgid = distID
            let instance = {
                'orgid': distID
            }
            ApiServices.RestPostCall('rtmpro/component/org/hierarchydata', instance).then(res => {
                this.facilityList = res.data.nodes
            })
            // console.log(this.districtList,distID)
            // Object.keys(this.districtList).forEach(key => {
            //     if (this.districtList[key].id == distID) {
            //         this.facilityList = this.districtList[key].nodes

            //     }
            // })
        },
        cityChange(event) {
            let cityID = event.target.value;
            this.filterOrgid = cityID
        },
        triggerFilter() {
            if (this.filterOrgid == '') {
                this.filterOrgid = this.userData.orgid
            }
            if(this.userData.programid == '1262097')
                this.getSubIndicator(this.filterOrgid)
            else
            this.getIndicators(this.filterOrgid)
            this.initRealTimeGoogleMaps(this.filterOrgid)
        },
        // Filter function END
        getSubIndicator(param) {
            this.$root.isLoading = true
            var instance = {
                "programid": this.userData.programid,
                "orgid": param,
                "role": this.userData.userrole,
                "language": "en",
                "orguid": this.userData.orguid,
                "fromdate": this.fromDate,
                "todate": this.toDate,
                // "agerange": "5",
            }
            if(this.ageGroup != ''){
                instance['agerange'] = "5"
            }else{
                this.getIndicators(param)
                return
            }
            ApiServices.RestPostCall('rtmpro/customindicator/getdashindicator/agewise', instance).then(res => {
                console.log(res)
                this.$root.isLoading = false

                if(this.ageGroup == '<'){
                    this.indexCaseReg = res.data["Index Case Registration"]["age<=5"]['index']
                    this.contactCaseScrened = res.data['Contact Cases Screening']["age<=5"]['Contact'] + res.data['Contact Cases Screening']["age<=5"]['index']
                    // this.contactCaseTested = res.data['Contact Cases Testing']
                    this.tb_Tested = res.data['TB Contact Cases Testing']["age<=5"]['Contact'] + res.data['TB Contact Cases Testing']["age<=5"]['index']
                    this.tbPositive = res.data['TB Positive']["age<=5"]['Contact'] + res.data['TB Positive']["age<=5"]['index']
                    this.ltbiTested = res.data['LTBI Contact Cases Testing']["age<=5"]['Contact'] + res.data['LTBI Contact Cases Testing']["age<=5"]['index']
                    this.ltbiPositive = res.data['LTBI Postive']["age<=5"]['Contact'] + res.data['LTBI Postive']["age<=5"]['index']
                    this.tbTretInit = res.data['TB Treatment Initiation']["age<=5"]['Contact'] + res.data['TB Treatment Initiation']["age<=5"]['index']
                    this.tbTretNonInt = parseInt(res.data['TB Positive']["age<=5"]['Contact'] + res.data['TB Positive']["age<=5"]['index']) - 
                                        parseInt(res.data['TB Treatment Initiation']["age<=5"]['Contact'] + res.data['TB Treatment Initiation']["age<=5"]['index'])
                    this.ltbiInit = res.data['LTBI Treatment Initiation']["age<=5"]['Contact']  + res.data['LTBI Treatment Initiation']["age<=5"]['index']
                    this.ltbiNonInt = parseInt(res.data['LTBI Postive']["age<=5"]['Contact'] + res.data['LTBI Postive']["age<=5"]['index']) - 
                                    parseInt(res.data['LTBI Treatment Initiation']["age<=5"]['Contact'] + res.data['LTBI Treatment Initiation']["age<=5"]['index'])
                    // this.ltbiComplete = res.data['LTBI Treatment OutCome']["age<=5"]['Contact'] + res.data['LTBI Treatment OutCome']["age<=5"]['index']
                    this.contactCaseTestedLtbi = res.data['Referred Contact For LTBI']["age<=5"]['Contact'] + res.data['Referred Contact For LTBI']["age<=5"]['index']
                    this.ltbirefered = res.data['Referred Contact For TB']["age<=5"]['Contact'] +  res.data['Referred Contact For TB']["age<=5"]['index']
                }else{
                    this.indexCaseReg = res.data["Index Case Registration"]["age>5"]['index']
                    this.contactCaseScrened = res.data['Contact Cases Screening']["age>5"]['Contact'] + res.data['Contact Cases Screening']["age>5"]['index']
                    // this.contactCaseTested = res.data['Contact Cases Testing']
                    this.tb_Tested = res.data['TB Contact Cases Testing']["age>5"]['Contact'] + res.data['TB Contact Cases Testing']["age>5"]['index']
                    this.tbPositive = res.data['TB Positive']["age>5"]['Contact'] + res.data['TB Positive']["age>5"]['index']
                    this.ltbiTested = res.data['LTBI Contact Cases Testing']["age>5"]['Contact'] + res.data['LTBI Contact Cases Testing']["age>5"]['index']
                    this.ltbiPositive = res.data['LTBI Postive']["age>5"]['Contact'] + res.data['LTBI Postive']["age>5"]['index']
                    this.tbTretInit = res.data['TB Treatment Initiation']["age>5"]['Contact'] + res.data['TB Treatment Initiation']["age>5"]['index']
                    this.tbTretNonInt = parseInt(res.data['TB Positive']["age>5"]['Contact'] + res.data['TB Positive']["age>5"]['index']) - 
                                        parseInt(res.data['TB Treatment Initiation']["age>5"]['Contact'] + res.data['TB Treatment Initiation']["age>5"]['index'])
                    this.ltbiInit = res.data['LTBI Treatment Initiation']["age>5"]['Contact']  + res.data['LTBI Treatment Initiation']["age>5"]['index']
                    this.ltbiNonInt = parseInt(res.data['LTBI Postive']["age>5"]['Contact'] + res.data['LTBI Postive']["age>5"]['index']) - 
                                    parseInt(res.data['LTBI Treatment Initiation']["age>5"]['Contact'] + res.data['LTBI Treatment Initiation']["age>5"]['index'])
                    // this.ltbiComplete = res.data['LTBI Treatment OutCome']["age>5"]['Contact'] + res.data['LTBI Treatment OutCome']["age>5"]['index']
                    this.contactCaseTestedLtbi = res.data['Referred Contact For LTBI']["age>5"]['Contact'] + res.data['Referred Contact For LTBI']["age>5"]['index']
                    this.ltbirefered = res.data['Referred Contact For TB']["age>5"]['Contact'] +  res.data['Referred Contact For TB']["age>5"]['index']
                }
            })
        },
        getIndicators(param) {
            //  console.log(this.userData)
            this.$root.isLoading = true
            var instance = {
                "programid": this.userData.programid,
                "orgid": param,
                "role": this.userData.userrole,
                "language": "en",
                "orguid": this.userData.orguid,
                "fromdate": this.fromDate,
                "todate": this.toDate
            }
            ApiServices.RestPostCall('rtmpro/customindicator/getdashindicator', instance).then(res => {
                // console.log(res)
                this.indexCaseReg = res.data["Index Case Registration"]
                this.contactCaseScrened = res.data['Contact Cases Screening']
                // this.contactCaseTested = res.data['Contact Cases Testing']
                this.tb_Tested = res.data['TB Contact Cases Testing']
                this.tbPositive = res.data['TB Positive']
                this.ltbiTested = res.data['LTBI Contact Cases Testing']
                this.ltbiPositive = res.data['LTBI Postive']
                this.tbTretInit = res.data['TB Treatment Initiation']
                this.tbTretNonInt = parseInt(res.data['TB Positive']) - parseInt(res.data['TB Treatment Initiation'])
                this.ltbiInit = res.data['LTBI Treatment Initiation'] ||  parseInt(res.data['TB preventive treatment'])
                this.ltbiNonInt = parseInt(res.data['LTBI Postive']) - (parseInt(res.data['LTBI Treatment Initiation']) ||  parseInt(res.data['TB preventive treatment']))
                // this.ltbiComplete = res.data['LTBI Treatment OutCome']
                this.contactCaseTestedLtbi = res.data['Referred Contact For LTBI']
                this.ltbirefered = res.data['Referred Contact For TB']
                var category1 = []
                var data1 = []
                var category = []
                var data = []
                Object.keys(res.data).forEach(key => {
                    if (key == 'TB Contact Cases Testing') {
                        category.push('Contacts tested for TB');
                        data.push(parseInt(res.data['TB Contact Cases Testing']));
                    }
                    if (key == 'TB Positive') {
                        category.push('TB Positive');
                        data.push(parseInt(res.data['TB Positive']));
                    }
                    // B
                    if (key == 'Contact Cases Screening') {
                        category.push('Contacts Registered');
                        data.push(parseInt(res.data['Contact Cases Screening']));
                    }
                    if (key == 'TB Treatment Initiation') {
                        category.push('TB Treatment Initiation');
                        data.push(parseInt(res.data['TB Treatment Initiation']));
                    }
                    //for ltbi
                    if (key == 'LTBI Contact Cases Testing') {
                        category1.push('Contacts tested for TBI');
                        data1.push(parseInt(res.data['LTBI Contact Cases Testing']));
                    }
                    if (key == 'LTBI Postive') {
                        category1.push('TBI Positive');
                        data1.push(parseInt(res.data['LTBI Postive']));
                    }
                    // B
                    if (key == 'Contact Cases Screening') {
                        category1.push('Contacts Registered');
                        data1.push(parseInt(res.data['Contact Cases Screening']));
                    }
                    if (key == 'LTBI Treatment Initiation') {
                        category1.push('TBI Treatment Initiation');
                        data1.push(parseInt(res.data['LTBI Treatment Initiation']));
                    }
                    if (key == 'TB preventive treatment') {
                        category1.push('TBI Treatment Initiation');
                        data1.push(parseInt(res.data['TB preventive treatment']));
                    }
                })
                this.chartOptions.xAxis.categories = category1
                this.chartOptions.series[0].data = data1
                this.chartOptions2.xAxis.categories = category
                this.chartOptions2.series[0].data = data
                this.$root.isLoading = false
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });
        },
        createCharts(){
            
        },
        initMap() {
            // this.map = new L.map('myMap').setView([12.8797, 121.7740], 8);
            // this.tileLayer = new L.tileLayer(
            //     'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png', {
            //         maxZoom: 18,
            //         attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
            //     }
            // )
            // this.tileLayer.addTo(this.map)
            let self = this
            this.tiles = 
            // L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //     maxZoom: 18,
            //     attribution: '&copy; <a href="//openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
            // });
             L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
                maxZoom: 18,
                attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
            });
            var layerObj = L.geoJson(this.inddata, {
                style:{
                    //stroke: true,
                    color: '#000',
                    weight: 0.8,
                    // opacity: 1,
                    fillOpacity: 0,
                    //className: className + " " + 'leaflet-layer-hover'
                }
                })
            this.map = L.map('myMap', {
                zoom: 5,
                layers: [self.tiles]
            });
            this.map.addLayer(layerObj)
            // var marker = new this.L.Marker([17.385044, 78.486671]);
            // marker.addTo(this.map);
        },
        initRealTimeGoogleMaps(alllocations) {
            let self = this
            this.$root.isLoading = true
            var instance = {
                "language": "en",
                "programid": this.userData.programid,
                "orgid": this.userData.orgid,
                "orguid": this.userData.orguid,
                "role": this.userData.role,
                "authparam": this.userData.authparam,
                "fromdate": this.fromDate,
                "todate": this.toDate
            }
            ApiServices.RestPostCall('rtmpro/component/realtimemap', instance).then(res => {
                console.log(res)
                this.$root.isLoading = false
                alllocations = res.data
                $.each(alllocations, function (key, val) {
                    delete val.teiid;
                    delete val.deviceId;
                    delete val.instanceId;
                    delete val.status;
                    delete val.sysUIC;
                });

                var alllatlong = [];
                $.each(alllocations, function (key, val) {
                    var loc = {
                        lat: Number(val.Latitude),
                        lng: Number(val.Longitude)
                    }
                    alllatlong.push(loc);
                });
                if (res.data.length == 0) {
                    alllatlong = [{
                        lat: 0,
                        lng: 0
                    }]
                }
                var bounds = new L.LatLngBounds(alllatlong);
                // var map = L.map('myMap', {
                //     zoom: 5,
                //     layers: [self.tiles]
                // });

                var mcg = L.markerClusterGroup({
                    chunkedLoading: true,
                    //singleMarkerMode: true,
                    spiderfyOnMaxZoom: true
                });
                var myIcon = L.icon({
                    iconUrl: '/marker.png',
                    iconSize: [40, 41],
                    iconAnchor: [22, 94],
                    popupAnchor: [-3, -76],
                    // shadowUrl: '../assets/img/location-pin.png',
                    shadowSize: [68, 95],
                    shadowAnchor: [22, 94]
                });
                // L.marker([50.505, 30.57], { icon: myIcon }).addTo(map);
                for (var i = 0; i < alllocations.length; i++) {
                    var a = alllocations[i];
                    var markerdata = "";
                    $.each(alllocations[i], function (key, val) {
                        if (key == 'UIC' || key == 'regDate' || key == 'Contact Name' || key == 'Contact Age' || key == 'Contact Gender' || key == 'Phone Number' || key == '') {
                            markerdata += "<p class='text-primary capitalise " + key + "'>" + key + ": " + val + "</p>";
                        }
                    })
                    var title = markerdata;
                    var marker = L.marker(new L.LatLng(a.Latitude, a.Longitude), {
                        icon: myIcon
                    }, {
                        title: title
                    });
                    marker.bindPopup(title);
                    mcg.addLayer(marker);
                }
                if (!this.map) {
                    this.initMap()
                }
                this.map.addLayer(mcg);
                this.map.fitBounds(bounds);
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });

        }
    },
    mounted() {
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        this.toDate = d.getFullYear() + '-' +
            (('' + month).length < 2 ? '0' : '') + month + '-' +
            (('' + day).length < 2 ? '0' : '') + day;
        this.fromDate = '2000-01-01'
        this.getIndicators(this.userData.orgid);
        this.getHierarchy(this.userData.orgid);
        // this.initMap()
        // this.getSubIndicator(this.userData.orgid)
        this.initRealTimeGoogleMaps(this.alllocations)
        // // console.log(res)
        let langLocal = JSON.parse(sessionStorage.getItem('langLocal'))
        for(let lang in langLocal){
            console.log(lang, langLocal[lang])
            this.$i18n.setLocaleMessage(lang,langLocal[lang])
        }
        // console.log(this.$i18n.locale,this.$root.localLang)
        // this.$i18n.locale = this.$root.localLang
            // self.$i18n.setLocaleMessage(res)
            // self.$router.push('/home')
    }
};
</script>

<style scoped>
.content-grid .card .card-body {
    height: calc(50vh - 49px);
}
</style>
